<template>
    <section>
        <v-container v-if="userCan('resellers_commissions')" >
            <v-row dense>
                <v-col class="col-md-4 col-xs-12">
                    <CommissionOverviewReportCard color='warning' title="تسویه نشده" :filters="{ 'status' : { 'column_name' : 'status', 'operand' : 'IsEqualTo', value : 'unpaid' }}"></CommissionOverviewReportCard>
                </v-col>
                <v-col class="col-md-4 col-xs-12">
                    <CommissionOverviewReportCard color="info" title="درحال تسویه" :filters="{ 'status' : { 'column_name' : 'status', 'operand' : 'IsEqualTo', value : 'paying' }}"></CommissionOverviewReportCard>
                </v-col>
                <v-col class="col-md-4 col-xs-12">
                    <CommissionOverviewReportCard color="success" title="تسویه شده" :filters="{ 'status' : { 'column_name' : 'status', 'operand' : 'IsEqualTo', value : 'paid' }}"></CommissionOverviewReportCard>
                </v-col>
            </v-row>
        </v-container>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('commissions')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                    <downloadExcel
                            class            = "btn"
                            :fetch           = "fetchAll"
                            :fields          = "excelFields"
                            name="commissions.xls"
                    >
                        <v-btn
                                icon
                                small
                        >
                            <v-icon right dark>mdi-file-excel</v-icon>
                        </v-btn>
                    </downloadExcel>
                </v-card-title>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template v-if="false" v-slot:top>
                        <div class="d-flex justify-start mb-6">
                            <v-text-field
                                    v-model="createdAtRengeLable"
                                    label="بازه خرید"
                                    class="mx-4 pa-1 hide"
                                    id="filters_created_at"
                                    readonly
                                    clearable
                                    @click:clear="resetCreatedAtRenge()"
                            ></v-text-field>
                            <date-picker
                                    v-model="created_at"
                                    range
                                    clearable
                                    format="X"
                                    display-format="jMMMM jD"
                                    element="filters_created_at"
                            />
                        </div>

                    </template>
                  <template #item.reseller_id="{item}">
                    <v-skeleton-loader
                        v-if="fetchingResellers"
                        type="text"
                        class="mt-2"
                    ></v-skeleton-loader>
                    <v-chip
                        v-else-if="resellers[item.reseller_id]"
                        x-small
                        color="success"
                        outlined>
                      {{resellers[item.reseller_id].name}}
                    </v-chip>
                    <v-chip
                        v-else
                        x-small
                        color="red"
                        outlined
                    >
                      غیره قابل نمایش
                    </v-chip>
                  </template>
                    <template #item.payer_user_id="{item}">
                        <span>
                            {{ item.payer_user_fullname}} {{item.payer_user_mobile}}
                        </span>
                    </template>
                    <template #item.fax_number_id="{item}">
                        <v-skeleton-loader
                                v-if="syncingFaxNumbers"
                                type="text"
                                class="mt-2"
                        ></v-skeleton-loader>
                        <v-chip
                                v-else-if="faxNumbers[item.fax_number_id]"
                                x-small
                                color="success"
                                outlined>
                            {{faxNumbers[item.fax_number_id].number}}

                        </v-chip>
                        <v-chip
                                v-else
                                x-small
                                color="red"
                                outlined>
                            غیره قابل نمایش
                        </v-chip>
                    </template>
                    <template #item.type="{item}">
                        {{ $t('commission_type')[item.type] }}
                    </template>


                    <template #item.total_pay="{item}">
                        {{$t('display_price', { price : $n( (item.amount * 100) / item.commission_rate )})}}
                    </template>
                    <template #item.commission_rate="{item}">
                        {{item.commission_rate}} %
                    </template>
                    <template #item.amount="{item}">
                        {{$t('display_price', { price : $n( item.amount)})}}
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.status="{item}">
                        <v-chip
                                v-if="item.status == 'paid'"
                                x-small
                                color="success">
                            تسویه شده
                        </v-chip>
                        <v-chip
                                v-else-if="item.status == 'paying'"
                                x-small
                                color="info">
                            درحال تسویه
                        </v-chip>
                        <v-chip
                                v-else
                                x-small
                                color="warning">
                            تسویه نشده
                        </v-chip>
                    </template>

                    <template #item.actions="{item}">
                        <v-tooltip top v-if="item.settlement_request_id">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'SettlementRequestDetails', params : { id : item.settlement_request_id } }"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-eye</v-icon>
                                </router-link>

                            </template>
                            <span>جزییات تسویه</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <router-link
                                :to="{ name: 'Receipts', query: { filters: [{ column_name : 'id', value: item.receipt_id, operand: 'IsEqualTo' }]} }"
                                class="no-decoration"
                            >
                              <v-icon v-bind="attrs"
                                      v-on="on"
                              >mdi-eye</v-icon>
                            </router-link>

                          </template>
                          <span>رسید پرداخت</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </section>
</template>

<script>
    import { mapState,mapActions, mapGetters } from 'vuex';

    import Service from "../services/CommissionsService";
    import FaxNumbersService from "../services/FaxNumbersService";

    import CommissionOverviewReportCard from "../components/CommissionOverviewReportCard";
    import downloadExcel from "vue-json-excel";

    import RequestList from "../services/RequestList";
    import CRUDMixin from '../mixins/CRUDMixin'

    export default {
        mixins : [CRUDMixin],

        components: {
            CommissionOverviewReportCard,
            downloadExcel
        },
        computed: {
            ...mapGetters({
                fetchingResellers : 'resellers/fetching',
            }),
            ...mapState({
                resellers : state => state.resellers.resellers
            }),
            createdAtRengeLable(){
                if(!this.created_at) return null;

                let fromLabel = this.created_at[0] ? `${this.getJalaliDate(this.created_at[0] * 1000, 'jD jMMM jYY')} ~ ` : '';
                let toLabel = this.created_at[1] ? `${this.getJalaliDate(this.created_at[1] * 1000, 'jD jMMM jYY')}` : '';

                return [fromLabel, toLabel].join(' ').trim();
            },
            excelFields(){
              let excelFields = {};
              this.headers.map(header => {
                if(header.xlsExport){
                  excelFields[header.text] = {
                    callback : header.xlsExport
                  }
                }
              });
              return excelFields;
            },
            zoneOptions(){
                return Object.keys(this.$t("zone_options")).map(key => {
                    return {
                        key,
                        value: this.$t("zone_options")[key]
                    }
                });
            }
        },
        watch: {
            zone(key){
                this.filters.vertical_service_code.value = undefined;

                switch (key){
                    case 'private' :
                        this.filters.vertical_service_code.operand = 'IsNull';
                        this.filters.vertical_service_code.value = null;
                        break;
                    case 'public' :
                        this.filters.vertical_service_code.operand = 'IsNotNull';
                        this.filters.vertical_service_code.value = null;
                        break;

                }
            },
            search(str){
                if( this.searchHandler ){
                    clearTimeout(this.searchHandler);
                }
                if(!str && this.filters.number.value){
                    this.filters.number.value = null;
                }

                if( str.length <= 3 ){
                    return '';
                }
                this.searchHandler = setTimeout( () => {
                    this.filters.number.value = str;
                    this.searchHandler = null;
                }, 1000);
            },
            dialog (val) {
                !val && this.close()
            },
            filters: {
                handler(filters) {
                    let filtersQuery = [];


                    Object.values(filters).map( filter => {
                        if(typeof filter.value != 'undefined'){
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query : {
                            filters : filtersQuery,
                            page : 1,
                            count : this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            }
        },
        data() {
            let headers = [
                {
                    text: this.$t('created_at'),
                    value: 'created_at',
                    xlsExport : (item) => {
                      return this.getJalaliDate(item.created_at * 1000);
                    }
                },
                {
                  text: this.$t('reseller'),
                  value: 'reseller_id',
                  xlsExport : (item) => {
                    return this.resellers[item.reseller_id] ? this.resellers[item.reseller_id].name : 'ناشناخته';
                  }
                },
                {
                    text: this.$t('commission_type_label'),
                    value: 'type',
                    xlsExport : (item) => {
                      return this.$t('commission_type')[item.type];
                    }
                },
                {
                    text: this.$t('fax_number'),
                    value: 'fax_number_id',
                    xlsExport : (item) => {
                      return this.faxNumbers[item.fax_number_id] ? this.faxNumbers[item.fax_number_id].number : 'ناشناخته';
                    }
                },
                {
                    text: this.$t('payer_user_id'),
                    value: 'payer_user_id',
                    xlsExport : (item) => {
                      return this.users[item.payer_user_id] ? this.users[item.payer_user_id].full_name : 'ناشناخته';
                    }
                },
                {
                    text: this.$t('total_pay'),
                    value: 'total_pay',
                    xlsExport : (item) => {
                      return (item.amount * 100) / item.commission_rate;
                    }
                },
                {
                    text: this.$t('commission_rate'),
                    value: 'commission_rate',
                    xlsExport : (item) => {
                      return item.commission_rate + ' %';
                    }
                },
                {
                    text: this.$t('amount'),
                    value: 'amount',
                    xlsExport : (item) => {
                      return item.amount;
                    }
                },
                {
                    text: 'وضعیت پرداخت',
                    value: 'status',
                    xlsExport : (item) => {
                      return item.status;
                    }
                },
                {
                    text: this.$t('action'),
                    value: 'actions',
                },
            ];

            return {
                searchHandler : null,
                item : null,
                faxNumbers : {},
                loading : false,
                zone : undefined,
                created_at : null,
                headers : headers,
                syncingFaxNumbers : false,
                filters : {
                    number : {
                        column_name : 'number',
                        operand : 'Contains',
                        value : undefined
                    },
                    state : {
                        column_name : 'state',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    vertical_service_code : {
                        column_name : 'vertical_service_code',
                        operand : 'IsNull',
                        value : undefined
                    },
                    user_id : {
                        column_name : 'user_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    status : {
                        column_name : 'status',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                },
                items : [],
                search : null,
            }
        },
        mounted() {
            this.syncResellers();
            this.syncFaxNumbers();
        },
        methods: {
            ...mapActions({
                syncResellers: 'resellers/sync',
            }),
            async syncFaxNumbers() {
                this.syncingFaxNumbers = true;
                this.faxNumbers = {};

                let requestList = new RequestList();

                requestList.addFilter('vertical_service_code', 'IsNull');

                try {
                    let {data} = await FaxNumbersService.list(requestList);
                    data.value.fax_numbers.forEach(faxNumbers => {
                      this.faxNumbers[faxNumbers.id] = faxNumbers;
                    });
                } finally {
                    this.syncingFaxNumbers = false;
                }
            },
            async fetch() {
                this.loading = true;

                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);

                requestList.addOrder('created_at','desc');
                requestList.setPage(page, count);

                if(this.created_at){
                    requestList.addFilter('created_at','Between', this.created_at)

                }
                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.commissions;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async fetchAll() {
                this.loading = true;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('created_at','desc');

                try {
                    let {data} = await Service.list(requestList);
                    return data.value.commissions;
                } finally {
                    this.loading = false;
                }
            },
            resetCreatedAtRenge() {
                this.created_at = undefined;
            }

        }
    }
</script>
